import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import English from '../json/en.json';
import French from '../json/fr.json';

i18n.use(initReactI18next).init({
  resources: { en: { translation: English }, fr: { translation: French } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
export const t = i18n.t.bind(i18n);
